var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{class:['reg-v-alert'],attrs:{"value":_vm.alertToggle,"type":_vm.messageData.type,"transition":"scale-transition"}},[_c('span',[_vm._v(_vm._s(_vm.messageData.messageText))])])}
var staticRenderFns = []

export { render, staticRenderFns }